import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import type { ObjetivoGenerico } from "../types";

interface Props {
  og: ObjetivoGenerico;
  checked: boolean;
  onToggle: () => void;
}

const ObjetivoGenericoItem: React.FC<Props> = ({ og, checked, onToggle }) => {
  return (
    <Box
      display="flex"
      alignItems="flex-start"
      gap={1}
      sx={{
        p: 0.8,
        borderRadius: "10px",
        cursor: "pointer",
        backgroundColor: checked ? "rgba(29, 61, 77, 0.10)" : "transparent",
        "&:hover": { backgroundColor: "rgba(0,0,0,0.04)" },
      }}
      onClick={onToggle}
    >
      <Checkbox
        checked={checked}
        onChange={onToggle}
        onClick={(e) => e.stopPropagation()}
      />
      <Typography
        sx={{
          fontFamily: "Montserrat",
          fontSize: "0.78rem",
          color: "rgba(0,0,0,0.78)",
          mt: 0.6,
          lineHeight: 1.25,
        }}
      >
        {og.texto}
      </Typography>
    </Box>
  );
};

export default ObjetivoGenericoItem;
